import { useMemo } from 'react'
import { ComponentWithPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import TwinTable from '../../../../../baseComponents/TwinTable'
import BaseScreenTableInner from '../../../../../baseComponents/TwinTable/BaseScreenTableInner'
import { TableComponentBaseScreenInnerProps } from '../../../../../baseComponents/TwinTable/BaseScreenTableInner/types'
import { CustomRenderBoolean, CustomRenderString } from '../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useProductActiveDictionary from '../../../../../utils/hooks/product/useProductActiveDictionary'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { ProductExtendedTyShort } from '../../../types'
import { ProductEscandallingWithLang } from './types'
import ModalCreateProductEscandalling from './ModalManageProductEscandalling'
import { DisplayPriceGettingParams } from '../../../../../baseComponents/Displays/DisplayPrice'
import { getISOCurrencyMain } from '../../../../../utils/reducers/getters'
import { ModalEditComponentProps } from '../../../../../baseComponents/ModalsLayouts/types'
import { useParams } from 'react-router-dom'
import useEditDeleteModal from '../../../../../utils/hooks/useEditDeleteModal'
import PermissionChecker from '../../../../../baseComponents/PermissionChecker'
import TwinTrans from '../../../../../baseComponents/TwinTrans'
import { ButtonPrimary } from '../../../../../baseComponents/Button'
interface ProductEscandallingProps extends ComponentWithPermissions {
    basicData: ProductExtendedTyShort
    getData: () => Promise<void>
}

const ProductEscandalling: React.FC<ProductEscandallingProps> = ({ basicData, userPermissions, getData }) => {
    const { t } = useTwinTranslation()
    const pageData = {
        title: t('escandalling', 'Escandallos'),
        newText: '',
    }

    return (
        <BaseScreenTableInner TableComponent={TableProductEscandalling} CreateModalComponent={ModalCreateProductEscandalling} pageData={pageData} userPermissions={userPermissions} extraWhereParams={{
            'ProductEscandallingRel.ProductId': basicData?.id
        }} basicData={{...basicData, getData}} RightHeader={RightHeaderUpdateProductsEscandalling} />
    )
}
type TableProductEscandallingProps = TableComponentBaseScreenInnerProps

const TableProductEscandalling: React.FC<TableProductEscandallingProps > = ({setTableInstance, extraWhereParams }) => {
    const { t } = useTwinTranslation()
    const { productActiveDict } = useProductActiveDictionary()

    const defaultCurrencyId = useMemo(() => {
        return getISOCurrencyMain()
    }, [])

    const columns: ColumnTableSchema<ProductEscandallingWithLang> = [
        {
            id: 'ProductEscandallingId',
            dataKey: 'ProductEscandallingId',
            label: t('id', 'ID'),
            width: 50,
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'cost',
            dataKey: 'cost',
            label: t('cost', 'Coste'),
            customRender: (value) => <DisplayPriceGettingParams value={parseFloat(String(value))} CurrencyId={defaultCurrencyId} with_vat={false} />
        },
        {
            id: 'margin',
            dataKey: 'margin',
            label: t('margin', 'Margen'),
            customRender: (value)=><CustomRenderString value={value  +  ' %'} />
        },
        {
            id: 'unitPriceCostWithMargin',
            dataKey: 'unitPriceCostWithMargin',
            label: t('costPriceWithMarginShort', 'PCM'),
            simpleLabel: t('costPriceWithMargin', 'Precio coste con margen'),
            toolTip: t('costPriceWithMargin', 'Precio coste con margen'),
            customRender: (value) => <DisplayPriceGettingParams value={parseFloat(String(value))} CurrencyId={defaultCurrencyId} with_vat={false} />
        },
        {
            id: 'active',
            dataKey: 'ProductMaterial.active' as any,
            label: t('active', 'Activo'),
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={45} />,
            hideColumnByDefault: true,
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSingle',
                extraComponentData: { items: productActiveDict, label: t('active', 'Activo') }
            },
            generalSearchable: false
        },
    ]
    return (
        <TwinTable columns={columns} name='subProductEscandalling' getDataFrom='/api/app/product/productEscandalling/getAllProductsEscandallingComplete' setTableInstance={setTableInstance} defaultOrder={{ 'defaultOrderField': 'order', order: 'asc' }} extraWhereParams={{ ...extraWhereParams }} />
    )
}

interface RightHeaderUpdateProductsEscandallingProps extends ModalEditComponentProps {}

const RightHeaderUpdateProductsEscandalling: React.FC<RightHeaderUpdateProductsEscandallingProps> = ({ onSubmit, userPermissions, basicData }) => {
    const { id } = useParams()
    const { openModal, setOpenModal } = useEditDeleteModal()
    return (
        <PermissionChecker userPermissions={userPermissions || false} permission={'update'}>
            <ButtonPrimary onClick={() => setOpenModal({ type: 'create', allRowData: { id } })}>
                <TwinTrans transKey='manage'>Gestionar</TwinTrans>
            </ButtonPrimary>
            {openModal?.type === 'create' && <ModalCreateProductEscandalling {...{ setOpened: () => setOpenModal(null) }} onSubmit={(res, vals) => {onSubmit(res, vals); basicData?.getData?.()}} userPermissions={userPermissions} basicData={basicData} />}
        </PermissionChecker>
    )
}


export default ProductEscandalling